import { defineStore } from 'pinia';

export const APP_STORE_ID = 'store-app';

type MaintenanceErrorType = 'deploy_in_progress' | 'maintenance_window' | 'network_unavailable' | null;

interface AppState {
  isInitialized: boolean;
  isMaintenanceMode: boolean;
  maintenanceMessage: string | null;
  maintenanceRetryAfter: number | null;
  maintenanceErrorType: MaintenanceErrorType;
  isGlobalLoading: boolean;
  globalLoadingMessage: string | null;
}

export const useAppStore = defineStore(APP_STORE_ID, {
  state: (): AppState => ({
    isInitialized: false,
    isMaintenanceMode: false,
    maintenanceMessage: null,
    maintenanceRetryAfter: null,
    maintenanceErrorType: null,
    isGlobalLoading: false,
    globalLoadingMessage: null,
  }),

  getters: {
    isReady: (state) => state.isInitialized && !state.isMaintenanceMode,
  },

  actions: {
    setInitialized() {
      this.isInitialized = true;
    },

    setMaintenanceMode(
      isMaintenanceMode: boolean,
      message?: string,
      retryAfter?: number,
      errorType?: MaintenanceErrorType,
    ) {
      this.isMaintenanceMode = isMaintenanceMode;
      this.maintenanceMessage = message || null;
      // `?? null` (not `|| null`): a valid `Retry-After: 0` ("retry immediately")
      // is falsy and would otherwise be dropped to null.
      this.maintenanceRetryAfter = retryAfter ?? null;
      this.maintenanceErrorType = errorType ?? null;
    },

    clearMaintenanceMode() {
      this.isMaintenanceMode = false;
      this.maintenanceMessage = null;
      this.maintenanceRetryAfter = null;
      this.maintenanceErrorType = null;
    },

    showGlobalLoading(message?: string) {
      this.isGlobalLoading = true;
      this.globalLoadingMessage = message || null;
    },

    hideGlobalLoading() {
      this.isGlobalLoading = false;
      this.globalLoadingMessage = null;
    },
  },
});
